/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
/**
 * Provides all nessesary aria-* attributes to create a valid aria modal.
 * Recommended use with `@focusTrap` controller.
 */
export function ariaModal() {
    return (target) => target.addInitializer((instance) => new AriaModalController(instance));
}
export class AriaModalController {
    constructor(host) {
        this.host = host;
        this.host.addController(this);
    }
    hostConnected() {
        // safari https://bugs.webkit.org/show_bug.cgi?id=174667
        this.host.ariaModal = 'true';
        this.host.role = 'dialog';
    }
}
